import {
  View,
  Text,
  ActivityIndicator,
  TextInput
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import Card from '../../shared/card/Card'
import { Formik } from 'formik'
import CustomButton from '../../shared/button/Button'
import { globalStyles } from '../../../static/styles/global'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import { usePersonalStore } from '../../../stores/personalInfo'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import Toast from 'react-native-toast-message'
import * as yup from 'yup'
import { CheckBox } from 'react-native-elements'
import { useState } from 'react'
import { mapSelectValue } from '../../../utils'

const MsInformationform = ({ navigation, route }: any) => {
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey
    } = params

    const { loading, postmsonline } = useFormsStore()
    const initializestore = useInitializeStore()
    const personalstore = usePersonalStore()
    const intialValues = {
        martialstatus: "",
        spouseemployed: null,
        additionalamount: "",
        spouseamount: null,
        dependents: "",
        age65: "",
        blind: "",
        exempt: ""
    }

    const options1 = [
        {
            key: 1,
            value: 'Single'
        },
        { key: 2, value: 'Married ' },
        { key: 3, value: 'Head of Household' }
    ]

    const options2 = [{

        key: 1,
        value: 'Spouse NOT employed'
    },
    { key: 2, value: 'Spouse IS employed' },
    ]

    const checkboxData = [
        { id: 1, title: 'Husband', isChecked: false },
        { id: 2, title: 'Wife', isChecked: false },
        { id: 3, title: 'Single', isChecked: false },
    ];


    const [checkboxes, setCheckboxes] = useState(checkboxData);

    const toggleCheckbox = (id: any) => {
        const newCheckboxes = checkboxes.map(checkbox =>
            checkbox.id === id ? { ...checkbox, isChecked: !checkbox.isChecked } : { ...checkbox, isChecked: false }
        );
        setCheckboxes(newCheckboxes);
    };


    const checkboxData2 = [
        { id: 1, title: 'Husband', isChecked: false },
        { id: 2, title: 'Wife', isChecked: false },
        { id: 3, title: 'Single', isChecked: false },
    ];


    const [checkboxes2, setCheckboxes2] = useState(checkboxData2);

    const toggleCheckbox2 = (id: any) => {
        const newCheckboxes = checkboxes2.map(checkbox =>
            checkbox.id === id ? { ...checkbox, isChecked: !checkbox.isChecked } : { ...checkbox, isChecked: false }
        );
        setCheckboxes2(newCheckboxes);
    };


    const getCheckedIds = () => {
        return checkboxes
            .filter(checkbox => checkbox.isChecked)
            .map(checkbox => checkbox.id.toString());
    };
    const getCheckedIds2 = () => {
        return checkboxes2
            .filter(checkbox => checkbox.isChecked)
            .map(checkbox => checkbox.id.toString());
    };



    const w4schema = () => {
        const baseSchema = {
            martialstatus: yup.string().required('Filing status is a required field'),
            spouseemployed: yup.string().when("martialstatus", (martialstatus: any, schema) => {
                if (martialstatus == 1) {
                    return schema.required('Is spouse employed is a required field')
                }
                return schema.nullable()

            }),
            spouseamount: yup.string().when("spouseemployed", (spouseemployed: any, schema) => {
                if (spouseemployed == 1) {
                    return schema.required('Enter the amount is a required field')
                }
                return schema.nullable()

            }),

            additionalamount: yup.string().nullable(),
            exempt: yup.string()
                .matches(/^exempt$/i, "Enter 'Exempt' or leave it empty")
                .nullable(),

            dependents: yup.string().required('No of dependents is a required field'),
            age65: yup.mixed().nullable(),
            blind: yup.mixed().nullable(),
        }
        return yup.object(baseSchema)
    }
    const schema = w4schema()

    return (
        <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'MS Withholding Taxation'}
                    />
                </View>
            </View>
            <View style={globalStyles.containerOverlap}>
                <Formik
                    initialValues={{ ...intialValues }}
                    validationSchema={schema}
                    onSubmit={async (values, actions) => {
                        let martialstatus_total = 0

                        if (Number(values.martialstatus) == 0) {
                            martialstatus_total = 6000;

                        }
                        else if (Number(values.martialstatus) == 2) {
                            martialstatus_total = 9500;
                        }
                        else {
                            if (Number(values.spouseemployed) == 0) {
                                martialstatus_total = 12000;
                            }
                            else {
                                martialstatus_total = 0;
                            }

                        }
                        const blind_and_age_total = (getCheckedIds().length) * 1500 + (getCheckedIds2().length) * 1500;

                        const age65 = getCheckedIds()
                        const blind = getCheckedIds2()




                        let total = martialstatus_total + Number(values?.spouseamount) + blind_and_age_total + Number(values?.dependents) * 1500
                        const data = {
                            entityId: personalstore?.personalData?.entityId,
                            essUserKey:
                                initializestore?.initializeData?.userkey,
                            essObKey: essUserOnBoardingKey,
                            essUserOnBoardingFormKey:
                                essUserOnBoardingFormKey,
                            completeOnline: mode == "online" ? true : false,
                            maritalStatus: values?.martialstatus,
                            spouseEmployed: values?.spouseemployed,
                            SpouseClaimedAmount: values?.spouseamount,
                            ageAndBlindnessAmount: blind_and_age_total,
                            totalAmount: total,
                            additionalWithholding: values?.additionalamount ? values?.additionalamount : null,
                            serviceMemberReliefExempt: values?.exempt?.toUpperCase(),
                            ageHusband: age65.includes('1') ? 1 : 0,
                            ageWife: age65.includes('2') ? 1 : 0,
                            ageSingle: age65.includes('3') ? 1 : 0,
                            blindnessHusband: blind.includes('1') ? 1 : 0,
                            blindnessWife: blind.includes('2') ? 1 : 0,
                            blindnessSingle: blind.includes('3') ? 1 : 0,
                            Dependents: values?.dependents ? Number(values?.dependents) : null

                        }

                        const response = await postmsonline(data)
                        if (response?.success) {
                            if (mode === 'online') {
                                navigation.navigate('MsInformationOnline', {
                                    userId,
                                    mode,
                                    essUserOnBoardingKey,
                                    essUserOnBoardingFormKey,
                                    values,
                                    blind_and_age_total,
                                    age65,
                                    blind,
                                    total
                                })
                            } else {
                                await Toast.show({
                                    type: 'success',
                                    position: 'bottom',
                                    text1: response?.message,
                                    visibilityTime: 3000,
                                    autoHide: true,
                                    topOffset: 60,
                                    onHide: () => {
                                        navigation.replace('OnboardingForms')
                                    }
                                })
                            }
                        } else {
                            await Toast.show({
                                type: 'error',
                                position: 'bottom',
                                text1: response?.message,
                                visibilityTime: 3000,
                                autoHide: true,
                                topOffset: 60
                            })
                        }
                    }}
                >
                    {(props) => (
                        <View>
                            <Card>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '65%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Martial Status *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '30%', overflow: 'hidden' }}>
                                        <SelectKeyValue
                                            title="Martial Status "
                                            options={options1}
                                            selectedOption={mapSelectValue(
                                                options1,
                                                props.values.martialstatus
                                            )}
                                            onSelect={(option: any) => {
                                                props.setFieldValue('spouseemployed', null)
                                                props.setFieldValue('martialstatus', option - 1)
                                            }}
                                            textColor="primary"
                                        />
                                        {props.touched.martialstatus &&
                                            props.errors.martialstatus && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.martialstatus}
                                                </Text>
                                            )}
                                    </View>
                                </View>

                                {Number(props.values.martialstatus) == 1 ?
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: '65%' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {'Is your spouse employed *'}
                                            </Text>
                                        </View>
                                        <View style={{ width: '30%', overflow: 'hidden' }}>
                                            <SelectKeyValue
                                                title="Is your spouse employed"
                                                options={options2}
                                                selectedOption={mapSelectValue(
                                                    options2,
                                                    props.values.spouseemployed
                                                )}
                                                onSelect={(option: any) => {
                                                    props.setFieldValue('spouseemployed', option - 1)
                                                }}
                                                textColor="primary"
                                            />
                                            {props.touched.spouseemployed &&
                                                props.errors.spouseemployed && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.spouseemployed as string}
                                                    </Text>
                                                )}
                                        </View>
                                    </View> : <></>}
                                {Number(props.values.spouseemployed) == 1 ?
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ width: '65%', justifyContent: 'center' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {
                                                    'Enter that part of $12,000 claimed by you in multiples of $500.*'
                                                }
                                            </Text>
                                        </View>
                                        <View style={{ width: '30%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.spouseamount}
                                                keyboardType="numeric"
                                                onChangeText={(text) => {
                                                    if (text === '' || /^\d+$/.test(text)) {
                                                        props.handleChange('spouseamount')(text)
                                                    }
                                                }}
                                            />
                                            {props.touched.spouseamount &&
                                                props.errors.spouseamount && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.spouseamount as string}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>
                                    : <></>
                                }


                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ width: '65%', justifyContent: 'center' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {
                                                'Enter the no of dependents *'
                                            }
                                        </Text>
                                    </View>
                                    <View style={{ width: '30%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.dependents}
                                            keyboardType="numeric"
                                            onChangeText={(text) => {
                                                if (text === '' || /^\d+$/.test(text)) {
                                                    props.handleChange('dependents')(text)
                                                }
                                            }}
                                        />
                                        {props.touched.dependents &&
                                            props.errors.dependents && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.dependents}
                                                </Text>
                                            )}
                                    </View>
                                </View>



                                <View
                                    style={[
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {
                                                ' Age 65 or older'
                                            }
                                        </Text>
                                    </View>
                                    <View style={{ flexDirection: "row", flexWrap: "wrap", overflow: 'hidden' }}>
                                        {checkboxes.map(checkbox => (
                                            <CheckBox
                                                key={checkbox.id}
                                                title={checkbox.title}
                                                checked={checkbox.isChecked}
                                                onPress={() => {
                                                    toggleCheckbox(checkbox.id)
                                                    props.setFieldValue("age65", getCheckedIds())

                                                }

                                                }
                                                checkedIcon="dot-circle-o"
                                                uncheckedIcon="circle-o"
                                                checkedColor="#0B495C"
                                                uncheckedColor="#0B495C"
                                                containerStyle={{ backgroundColor: 'transparent', borderWidth: 0 }}
                                                titleProps={{
                                                    style: {
                                                        fontWeight: "normal",
                                                        color: "#0B495C"
                                                    }
                                                }}
                                            />
                                        ))}
                                    </View>
                                    {props.touched.age65 &&
                                        props.errors.age65 && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.age65 as string}
                                            </Text>
                                        )}
                                </View>







                                <View
                                    style={[
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {
                                                'Blind'
                                            }
                                        </Text>
                                    </View>
                                    <View style={{ flexDirection: "row", flexWrap: "wrap", overflow: 'hidden' }}>
                                        {checkboxes2.map(checkbox => (
                                            <CheckBox
                                                key={checkbox.id}
                                                title={checkbox.title}
                                                checked={checkbox.isChecked}
                                                onPress={() => {
                                                    toggleCheckbox2(checkbox.id)
                                                    props.setFieldValue("blind", getCheckedIds2())

                                                }

                                                }
                                                checkedIcon="dot-circle-o"
                                                uncheckedIcon="circle-o"
                                                checkedColor="#0B495C"
                                                uncheckedColor="#0B495C"
                                                containerStyle={{ backgroundColor: 'transparent', borderWidth: 0 }}
                                                titleProps={{
                                                    style: {
                                                        fontWeight: "normal",
                                                        color: "#0B495C"
                                                    }
                                                }}
                                            />
                                        ))}
                                    </View>
                                    {props.touched.blind &&
                                        props.errors.blind && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.blind as string}
                                            </Text>
                                        )}
                                </View>







                                {props.values.exempt?.toLowerCase() !== 'exempt' && (
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ width: '65%', justifyContent: 'center' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {
                                                    'Additional dollar amount of withholding per pay period if agreed to by your employer '
                                                }
                                            </Text>
                                        </View>
                                        <View style={{ width: '30%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.additionalamount}
                                                keyboardType="numeric"
                                                onChangeText={(text) => {
                                                    if (text === '' || /^\d+$/.test(text)) {
                                                        props.handleChange('additionalamount')(text)
                                                    }
                                                }}
                                            />
                                            {props.touched.additionalamount &&
                                                props.errors.additionalamount && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.additionalamount}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>
                                )}
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ width: '65%', justifyContent: 'center' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {
                                                `If you qualify for exemption, enter 'Exempt'`
                                            }
                                        </Text>
                                    </View>
                                    <View style={{ width: '30%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.exempt}
                                            onChangeText={(text) => {
                                                props.handleChange('exempt')(text)
                                                if (text?.toLowerCase() === 'exempt') {
                                                    props.setFieldValue('additionalamount', '')
                                                }
                                            }}
                                        />
                                        {props.touched.exempt &&
                                            props.errors.exempt && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.exempt}
                                                </Text>
                                            )}
                                    </View>
                                </View>


                                {loading ? (
                                    <ActivityIndicator />
                                ) : (
                                    <View style={{ margin: 10 }}>
                                        <CustomButton
                                            text={mode === 'upload' ? 'Submit Information' : 'Next'}
                                            onPress={props.handleSubmit}
                                        />
                                    </View>
                                )}
                            </Card>
                        </View>
                    )}
                </Formik>
            </View>

        </KeyboardAwareScrollView>
    )
}

export default MsInformationform